import { useI18n } from '~/common/context';
import React from 'react';
import { Button, Text } from '@wyz/ui';
import { useBoolean } from '@wyz/utils';
type CollapsibleListProps<T> = {
  items: Array<T>;
  renderItem: (item: T, index: number) => React.ReactNode;
  limit: number;
};
const CollapsibleList = <T,>({
  items,
  renderItem,
  limit,
}: CollapsibleListProps<T>) => {
  const [collapsed, handlers] = useBoolean(true);
  const { t } = useI18n();

  return (
    <div className='position-relative'>
      <ul>
        {items
          .slice(0, collapsed ? limit : undefined)
          .map((item, index) => renderItem(item, index))}
      </ul>
      {items.length > limit && (
        <Button
          id='see-more'
          variant='link'
          onClick={handlers.toggle}
          fullWidth
        >
          <Text color='tertiary' weight='semi-bold' heading='xs'>
            {collapsed ? t('app.common.see_more') : t('app.common.see_less')}
          </Text>
        </Button>
      )}
    </div>
  );
};

export default CollapsibleList;
